import { signupSchema } from '../sign-up/schema';
import { z } from 'zod';

export const loginSchema = signupSchema.pick({
  company_id: true,
  phone_number: true,
});

export type LoginSchema = z.infer<typeof loginSchema>;

export const otpSchema = loginSchema.extend({
  password: z.string().length(4),
});

export type OtpSchema = z.infer<typeof otpSchema>;
